module.exports = __webpack_public_path__ + "static/media/RateCards.bf30149a.svg";